import ddt from '@wix/da-ddt';
import { toJsonString, isSSR } from '../utils';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { mergeEventDataWithContext } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { ADUNIT_MAP } from '../constants';
export const DEV_SCRIPT_URL = 'https://s.nitropay.com/ads-1240.js';
export const PROD_SCRIPT_URL = 'https://s.nitropay.com/ads-1239.js';
class NitroAds {
    logBi(eventData) {
        // Limit units to 2 logs max
        const loggedId = `${eventData.adUnitId}${eventData.evid}`;
        if (this.biLogged[loggedId] >= 2) {
            ddt.log('ads', 'Skip BI at limit', loggedId);
            return;
        }
        var _this_biLogged_loggedId;
        this.biLogged[loggedId] = ((_this_biLogged_loggedId = this.biLogged[loggedId]) !== null && _this_biLogged_loggedId !== void 0 ? _this_biLogged_loggedId : 0) + 1;
        if (!this.biContext) {
            this.logQueue.push(eventData);
            return;
        }
        biLogger.log(this.publicSession, mergeEventDataWithContext(eventData, this.biContext), false);
        this.flushBiQueue();
    }
    flushBiQueue() {
        if (this.logQueue.length > 0) {
            for (const item of this.logQueue){
                biLogger.log(this.publicSession, mergeEventDataWithContext(item, this.biContext), false);
            }
            this.logQueue = [];
        }
    }
    init() {
        if (!isSSR()) {
            try {
                // Replay events that happen before react lives
                if (window.__DAADS__ && Array.isArray(window.__DAADS__.ev)) {
                    for (const storedEvt of window.__DAADS__.ev){
                        ddt.log('ads', `nitro boot evt ${storedEvt.ev}`, storedEvt === null || storedEvt === void 0 ? void 0 : storedEvt.e);
                        if (storedEvt.ev === 'prepare') {
                            var _storedEvt_e, _storedEvt_e_holder;
                            this.logBi(BiData({
                                evid: 8883,
                                adUnitId: storedEvt === null || storedEvt === void 0 ? void 0 : (_storedEvt_e = storedEvt.e) === null || _storedEvt_e === void 0 ? void 0 : (_storedEvt_e_holder = _storedEvt_e.holder) === null || _storedEvt_e_holder === void 0 ? void 0 : _storedEvt_e_holder.id,
                                unsafe: BiContextProvidedValue,
                                itemid: BiContextProvidedValue,
                                typeid: BiContextProvidedValue
                            }));
                        }
                        if (storedEvt.ev === 'rendered') {
                            var _storedEvt_e1, _storedEvt_e_adInfo, _storedEvt_e2, _storedEvt_e3, _storedEvt_e4;
                            this.logBi(BiData({
                                evid: 8885,
                                adUnitId: storedEvt === null || storedEvt === void 0 ? void 0 : (_storedEvt_e1 = storedEvt.e) === null || _storedEvt_e1 === void 0 ? void 0 : (_storedEvt_e_adInfo = _storedEvt_e1.adInfo) === null || _storedEvt_e_adInfo === void 0 ? void 0 : _storedEvt_e_adInfo.adUnitCode,
                                unsafe: BiContextProvidedValue,
                                itemid: BiContextProvidedValue,
                                typeid: BiContextProvidedValue,
                                type: storedEvt === null || storedEvt === void 0 ? void 0 : (_storedEvt_e2 = storedEvt.e) === null || _storedEvt_e2 === void 0 ? void 0 : _storedEvt_e2.type,
                                adInfo: castAdInfoCpm(storedEvt === null || storedEvt === void 0 ? void 0 : (_storedEvt_e3 = storedEvt.e) === null || _storedEvt_e3 === void 0 ? void 0 : _storedEvt_e3.adInfo),
                                cpmText: `${storedEvt === null || storedEvt === void 0 ? void 0 : (_storedEvt_e4 = storedEvt.e) === null || _storedEvt_e4 === void 0 ? void 0 : _storedEvt_e4.adInfo.cpm}`
                            }));
                        }
                    }
                    window.__DAADS__.ev = false;
                }
                // Events for BI/Debug
                document.addEventListener('nitroAds.loaded', (event)=>{
                    ddt.log('ads', 'nitro evt loaded', event === null || event === void 0 ? void 0 : event.detail);
                });
                document.addEventListener('nitroAds.createAd', (event)=>{
                    ddt.log('ads', 'nitro evt createAd', event === null || event === void 0 ? void 0 : event.detail);
                });
                document.addEventListener('nitroAds.prepare', (event)=>{
                    ddt.log('ads', 'nitro evt prepare', event === null || event === void 0 ? void 0 : event.detail);
                    this.logBi(BiData({
                        evid: 8883,
                        adUnitId: event.detail.holder.id,
                        unsafe: BiContextProvidedValue,
                        itemid: BiContextProvidedValue,
                        typeid: BiContextProvidedValue
                    }));
                });
                document.addEventListener('nitroAds.bidReceived', (event)=>{
                    ddt.log('ads', 'nitro evt bid', event === null || event === void 0 ? void 0 : event.detail);
                });
                document.addEventListener('nitroAds.rendered', (event)=>{
                    ddt.log('ads', 'nitro evt rendered', event === null || event === void 0 ? void 0 : event.detail);
                    this.logBi(BiData({
                        evid: 8885,
                        adUnitId: event.detail.adInfo.adUnitCode,
                        unsafe: BiContextProvidedValue,
                        itemid: BiContextProvidedValue,
                        typeid: BiContextProvidedValue,
                        type: event.detail.type,
                        adInfo: castAdInfoCpm(event.detail.adInfo),
                        cpmText: `${event.detail.adInfo.cpm}`
                    }));
                });
                document.addEventListener('nitroAds.anchorVisibility', (event)=>{
                    ddt.log('ads', 'nitro evt anchorVis', event === null || event === void 0 ? void 0 : event.detail);
                });
                document.addEventListener('nitroAds.complete', (event)=>{
                    ddt.log('ads', 'nitro evt complete', event === null || event === void 0 ? void 0 : event.detail);
                    this.logBi(BiData({
                        evid: 8888,
                        adUnitId: event.detail.adUnitCode,
                        unsafe: BiContextProvidedValue,
                        itemid: BiContextProvidedValue,
                        typeid: BiContextProvidedValue,
                        type: event.detail.type
                    }));
                });
                window.addEventListener('pagehide', ()=>{
                    this.flushBiQueue();
                });
            } catch (e) {
                ddt.alertOnError(e, 'ads', 'Fatal in ads BI', [
                    'ads'
                ], e.message);
            }
        }
    }
    registerUnit(unitId, options) {
        if (!isSSR()) {
            ddt.log('ads', 'register nitro client ad', unitId);
            window['nitroAds'].createAd(unitId, options);
        } else {
            ddt.log('ads', 'register nitro ssr ad', unitId);
            this.ssrUnits[unitId] = options;
        }
    }
    killUnit(unitId) {
        // noop as nitro auto cleanup once the ad is removed from DOM
        // Extra cleanup for adhesion ads because they can hang around and end up on
        // unsafe things.
        if (unitId === ADUNIT_MAP['MobileAdhesion']) {
            const wrapper = document.getElementById(ADUNIT_MAP['MobileAdhesion']);
            if (wrapper) {
                var _wrapper_parentElement;
                ddt.log('ads', 'nitro cleanup adhesion m', wrapper);
                (_wrapper_parentElement = wrapper.parentElement) === null || _wrapper_parentElement === void 0 ? void 0 : _wrapper_parentElement.removeChild(wrapper);
            }
        }
        if (unitId === ADUNIT_MAP['DesktopAdhesion']) {
            const wrapper1 = document.getElementById(ADUNIT_MAP['DesktopAdhesion']);
            if (wrapper1) {
                var _wrapper_parentElement1;
                ddt.log('ads', 'nitro cleanup adhesion d', wrapper1);
                (_wrapper_parentElement1 = wrapper1.parentElement) === null || _wrapper_parentElement1 === void 0 ? void 0 : _wrapper_parentElement1.removeChild(wrapper1);
            }
        }
    }
    toSSR() {
        let output = '';
        for (const key of Object.keys(this.ssrUnits)){
            output = `${output}\nwindow["nitroAds"].createAd("${key}", JSON.parse(${toJsonString(this.ssrUnits[key])}));`;
        }
        return output;
    }
    setBiContext(context, session) {
        this.biContext = context;
        this.publicSession = session;
    }
    constructor(){
        this.ssrUnits = {};
        this.logQueue = [];
        this.biLogged = {};
    }
}
function castAdInfoCpm(adInfo) {
    return JSON.stringify(adInfo);
}
export default NitroAds;
